<template>
    <div :class="$style.sticky_banner">
        <BaseLink
            target="_blank"
            :externalTo="logoLink"
        >
            <Typography
                is="div"
                type="caption"
                size="s"
                :class="$style.logoContainer"
            >
                {{ $tr('widgetGame.powered_by') }}
                <Logo
                    :class="$style.logo_override"
                    mode="full"
                    noLink
                />
            </Typography>
        </BaseLink>
    </div>
</template>

<script setup lang="ts">
import BaseLink from '@/components_new/BaseLink.vue'
import Logo from '@/components_new/Logo/Logo.vue'
import Typography from '@/components_new/Typography.vue'
import { useConfig } from '@/composables/config'

const { VUE_APP_HOST_URL } = useConfig()
const logoLink = `${VUE_APP_HOST_URL}?from=widget` // TODO keep clid?
</script>

<style module>
.sticky_banner {
    display: flex;
    width: 100%;
    gap: 8px;
    background-color: var(--white);
    height: 100%;
    align-items: center;
    box-sizing: border-box;
    padding: 9px 20px 0;
}

.logoContainer {
    display: flex;
    flex-direction: column;
    gap: 2px;
    opacity: 0.2;
    color: var(--black);
    line-height: 100%;
}
.logo_override {
    color: var(--black);
    width: 126px;
    height: 20px;
}
</style>
